import 'core-js/stable';
import $ from 'jquery';
import App from 'root/app';

$(function() {
    var app = new App();

    app.init({
        host: window.app_configs.host,
        debug: !!window.app_configs.debug
    });
});
